import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AsyncPipe, DecimalPipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { SvgIconComponent } from 'angular-svg-icon';
import { SharedModule } from '@app/shared/shared.module';

export interface FeeOption {
  rangeKey: string;
  czk: number;
  eur: number;
}

export const FEE_OPTIONS: FeeOption[] = [
  { rangeKey: 'otc-desk.fees.ranges.5to10', czk: 1.5, eur: 1.2 },
  { rangeKey: 'otc-desk.fees.ranges.10to39', czk: 1.3, eur: 1.0 },
  { rangeKey: 'otc-desk.fees.ranges.39plus', czk: 1.1, eur: 0.8 },
];

@Component({
  selector: 'app-otc-fees-table',
  templateUrl: './fees-table.component.html',
  standalone: false,
})
export class OtcFeesTableComponent {
  feeOptions = FEE_OPTIONS;
  infoExpanded = false;

  toggleInfo() {
    this.infoExpanded = !this.infoExpanded;
  }
}
